import React from 'react'
import { Stack, Text } from '@mantine/core'
import { useTheme } from '../../components/ThemeProvider'

interface Field {
  label: string
  value?: string | number | React.ReactNode
  highlight?: boolean
  span?: 1 | 2
}

interface TianyanchaRecordCardProps {
  number: number
  fields: Field[]
  recordType?: string
}

export default function TianyanchaRecordCard({ number, fields, recordType = '记录' }: TianyanchaRecordCardProps) {
  const theme = useTheme()

  const renderField = (field: Field) => {
    const isHighlight = field.highlight && typeof field.value === 'string'
    const textColor = isHighlight ? theme.warningColor : undefined

    return (
      <div key={field.label} className={`flex flex-col gap-1 ${field.span === 2 ? 'md:col-span-2' : ''}`}>
        <Text size="xs" c="dimmed">
          {field.label}
        </Text>
        <Text size="sm" className="text-gray-700" fw={500} style={{ color: textColor, wordBreak: 'break-word' }}>
          {field.value || '—'}
        </Text>
      </div>
    )
  }

  return (
    <div
      className="rounded-lg border px-4 py-4"
      style={{
        borderColor: theme.surfaceBorderColor,
        backgroundColor: theme.surfaceColor,
      }}
    >
      <Stack gap="sm">
        <Text size="xs" c="dimmed">
          {recordType} {number}
        </Text>
        <div className="grid gap-3 md:grid-cols-2">
          {fields.filter((f) => f.value).map((field) => renderField(field))}
        </div>
      </Stack>
    </div>
  )
}
